import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, CanMatchFn, Route, Router, UrlTree } from '@angular/router';
import { AppEnvironmentService } from './app-environment.service';
import { MenuBuilder } from './models/menu-builder';
import { UserSessionService } from './user-session/user-session.service';

function getGuardFunctionalityId(route: ActivatedRouteSnapshot | Route): number | undefined {
  return route.data?.['functionalityId'] ?? ('parent' in route ? route.parent?.data?.['functionalityId'] : undefined);
}

function checkRouteAccess(route: ActivatedRouteSnapshot | Route): boolean | UrlTree {
  const appEnvironmentService = inject(AppEnvironmentService);
  const router = inject(Router);
  const userSessionService = inject(UserSessionService);

  if (!appEnvironmentService.isLoggedIn) {
    return router.createUrlTree(['/authentication']);
  }

  const functionalityId = getGuardFunctionalityId(route);

  //Note: 😏😏 Only do functionality-based permission validation when a functionalityId exists and the user is not a super user.
  if (!functionalityId || userSessionService.isSuperUser) {
    return true;
  }

  const hasAccess = userSessionService
    .getUserAuthorization(functionalityId)
    .canViewList() || userSessionService.getUserAuthorization(functionalityId).canView();

  if (!hasAccess) {
    return router.parseUrl(`/${MenuBuilder.UserHome}`);
  }

  return true;
}

export const authGuardGuard: CanActivateFn = (route, state) => {
  return checkRouteAccess(route);
};

export const authGuardChildGuard: CanActivateChildFn = (childRoute) => {
  return checkRouteAccess(childRoute);
};

export const authGuardMatchGuard: CanMatchFn = (route) => {
  return checkRouteAccess(route);
};
